import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { SectionBg } from "@/components/SectionBg";
import { scrollToId } from "@/lib/scroll";

const CARDS = [
  { sym: "01", text: "People who have not yet verified VA home loan eligibility or entitlement" },
  { sym: "02", text: "Eligible buyers preparing for a first use of VA financing" },
  { sym: "03", text: "Prior VA borrowers with questions about possible remaining entitlement" },
  { sym: "04", text: "Florida buyers comparing VA with other potential financing paths" },
  { sym: "05", text: "People who want cash, credit, offer, and next-step questions organized before applying" },
];

/* SECTION 5 — AUDIENCE FIT */
export const Audience = () => (
  <section id="learn" className="relative overflow-hidden px-5 md:px-10 lg:px-16 py-28 md:py-36 hairline-t" data-testid="audience-section">
    <SectionBg img="bg-home-6.jpg" strength={0.92} />
    <SectionParticles variant="circles" />
    <div className="relative z-10 max-w-6xl mx-auto text-left">
      <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-10">
        [003] — WHO THIS IS FOR
      </p>
      <Reveal>
        <h2 className="font-display font-medium text-base md:text-lg tracking-[0.08em] text-white max-w-3xl mb-14 uppercase">
          This educational workshop is designed for people exploring:
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
        {CARDS.map((c, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div
              data-testid={`audience-card-${i}`}
              className="h-full glass-panel rounded-[6px] p-7 hover:border-[rgba(148,222,82,0.4)] transition-colors duration-300 group"
            >
              <span className="font-mono text-3xl text-[rgba(255,255,255,0.14)] group-hover:text-[rgba(148,222,82,0.45)] transition-colors duration-300 block mb-5">
                {c.sym}
              </span>
              <p className="text-sm md:text-base leading-relaxed text-[rgba(255,255,255,0.82)]">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <button
        data-testid="audience-cta-button"
        onClick={() => scrollToId("register")}
        className="glint bg-[var(--accent)] text-[var(--background-deep)] font-semibold text-sm tracking-[0.12em] px-8 py-4 rounded-[4px] hover:brightness-110 hover:-translate-y-[1px] transition-[transform,filter] duration-200"
      >
        RESERVE MY FREE SEAT
      </button>
    </div>
  </section>
);
